import React from "react";
import Link from "next/link";
import { BiPhone, BiEnvelope, BiLogoLinkedin } from "react-icons/bi";
import { useTranslations } from '../../locales/useTranslations';

const KiInfoAndCTA = () => {
  const { t } = useTranslations();
  return (
    <>
      <div className="service-details pb-70">
        <div className="container">
          <div className="service-details-content">

            <div className="pt-35">
              <h2>{t('ki_infoAndCTA_title')}</h2>
              <p>
                {t('ki_infoAndCTA_description')}
              </p>
            </div>

            <div className="ki-blog-highlight pt-35">
              <div className="ki-blog-highlight__list">
                <div className="ki-blog-highlight__card">
                  <span className="ki-blog-highlight__badge">{t('ki_blog_highlight_badge')}</span>
                  <h3 className="ki-blog-highlight__title">{t('ki_blog_highlight_title')}</h3>
                  <p className="ki-blog-highlight__description">{t('ki_blog_highlight_description')}</p>
                  <Link href={t('ki_blog_highlight_path')} className="default-btn">
                    {t('ki_blog_highlight_link')}
                  </Link>
                </div>
                <div className="ki-blog-highlight__card">
                  <span className="ki-blog-highlight__badge">{t('ki_blog_highlight_badge')}</span>
                  <h3 className="ki-blog-highlight__title">{t('ki_blog_highlight2_title')}</h3>
                  <p className="ki-blog-highlight__description">{t('ki_blog_highlight2_description')}</p>
                  <Link href={t('ki_blog_highlight2_path')} className="default-btn">
                    {t('ki_blog_highlight_link')}
                  </Link>
                </div>
              </div>
            </div>

            <div className="pt-35">
              <h3>{t('ki_infoAndCTA_title2')}</h3>
              <p>
                {t('ki_infoAndCTA_description2')}
              </p>
            </div>

            <div className="service-details pt-35">
              <div className="service-details-info ">
                <div className="large-info-box">
                  <h4>{t('ki_infoAndCTA_title3')}</h4>
                  <span>{t('ki_infoAndCTA_description3')}</span>
                </div>

                <div className="single-info-box">
                  <h4>{t('ki_infoAndCTA_title4')}</h4>
                  <ul className="social">
                    <li>
                      <a href="tel://+4943170577024" target="_blank">
                        <BiPhone />
                      </a>
                    </li>
                    <li>
                      <a href="mailto:info@simplify-data.de" target="_blank">
                        <BiEnvelope />
                      </a>
                    </li>
                    <li>
                      <a href="https://www.linkedin.com/company/simplify-data-gmbh" target="_blank">
                        <BiLogoLinkedin />
                      </a>
                    </li>
                  </ul>
                </div>

                <div className="single-info-box">
                  <Link href="/kontakt/" className="default-btn">
                    {t('ki_infoAndCTA_button')}
                  </Link>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </>
  );
};

export default KiInfoAndCTA;
